var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #87c874;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: #396ba9;\n      }\n\n      .cls-5 {\n        fill: #ffb32c;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.37,
    y1: 321.31,
    x2: 108.37,
    y2: 120.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#194483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#17427f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#113c74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#093466"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 335.63,
    y1: 321.31,
    x2: 335.63,
    y2: 120.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79bb69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#75b865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6cb15a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5ca548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4c9936"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.15,120.8h0v164.74c0,19.75-16.03,35.78-35.78,35.78h0c-19.75,0-35.78-16.03-35.78-35.78v-93.19c0-39.49,32.06-71.56,71.56-71.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M299.85,120.8h0c39.49,0,71.56,32.06,71.56,71.56v93.19c0,19.75-16.03,35.78-35.78,35.78h0c-19.75,0-35.78-16.03-35.78-35.78V120.8h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.07,139.61s19.63-4.96,56.52,54.59l41.33,71.56s16.89,20.44,45.33,6.67c28.44-13.78,13.33-48,13.33-48l-42.08-72.94c-4.03-6.99-9.6-12.99-16.36-17.38-10.5-6.82-27.65-14.63-50-13.3,0,0-26.44-1.48-48.07,18.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.93,153.61l41.78,70.81,32-50.37s22.14-34.68,42.92-35.86c0,0-18.92-17.4-46.77-17.4,0,0-23.7-3.33-45.04,9.11s-24.89,23.7-24.89,23.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.52,107.72c-18.89,3.39-23.02,7.52-26.41,26.41-.18,1.03-1.66,1.03-1.85,0-3.39-18.89-7.52-23.02-26.41-26.41-1.03-.18-1.03-1.66,0-1.85,18.89-3.39,23.02-7.52,26.41-26.41.18-1.03,1.66-1.03,1.85,0,3.39,18.89,7.52,23.02,26.41,26.41,1.03.18,1.03,1.66,0,1.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.5d50b94fa3f1b325da80bf5727739b0d.svg";
export { ForwardRef as ReactComponent };